<template>
  <q-page padding class="container">
    <div class="row q-gutter-sm">
      <div class="col-xs-12 col-sm-8">
        <p class="text-h6 text-weight-bold text-brand-5 texto-titulo">
          Lista de Integrações
        </p>
      </div>
    </div>
    <div
      class="row col-12 q-gutter-sm text-brand-5 text-weight-bold q-mt-md container-inputs"
    ></div>
    <div class="row q-mt-xl">
      <div>
        <q-btn
          label="Criar Novo"
          no-caps
          color="primary"
          :outline="!rightDrawerOpen"
          icon="add_circle_outline"
          @click="(rightDrawerOpen = true), (rightDrawerOpenFiltro = false)"
        />
      </div>
      <div class="q-ml-sm">
        <q-btn
          label="Filtros"
          no-caps
          color="black"
          :outline="!rightDrawerOpenFiltro"
          icon="tune"
          @click="(rightDrawerOpenFiltro = true), (rightDrawerOpen = false)"
        />
      </div>
    </div>
    <div class="row col-12 q-ml-md q-mt-md text-brand-5 text-weight-bold">
      <div v-for="(filtro, index) in filtrosAplicados" :key="index">
        <div
          class="row col-12 q-mr-sm q-mt-md items-center justify-between card-nome-filtro"
          @click="rightDrawerOpenFiltro = true"
          style="cursor: pointer"
        >
          <span>{{ filtro }}</span>
        </div>
      </div>
    </div>
    <div class="q-mt-xl">
      <div class="q-my-md">
        <span class="q-ml-md text-brand-5 text-weight-bold text-subtitle1"
          >Integrações</span
        >
      </div>
      <q-table
        :columns="columns"
        :rows="listaSistemasIntegracoes"
        flat
        :loading="loading"
        class="tabela-tamanho-fixo"
        dense
        color="primary"
        table-header-class="bg-accent text-weight-bold"
      >
        <template v-slot:body-cell-cliente="props">
          <q-td class="text-brand-5 text-weight-bold" :props="props">{{
            props.row.clienteId
          }}</q-td>
        </template>
        <template v-slot:body-cell-unidade="props">
          <q-td class="text-brand-5 text-weight-bold" :props="props">{{
            props.row.unidade
          }}</q-td>
        </template>
        <template v-slot:body-cell-sistema="props">
          <q-td class="text-brand-5 text-weight-bold" :props="props">{{
            props.row.sistema
          }}</q-td>
        </template>
        <template v-slot:body-cell-tipoIntegracao="props">
          <q-td class="text-brand-5 text-weight-bold" :props="props">{{
            props.row.tipo
          }}</q-td>
        </template>
        <template v-slot:body-cell-versao="props">
          <q-td class="text-brand-5 text-weight-bold" :props="props">{{
            props.row.versao
          }}</q-td>
        </template>
        <template v-slot:body-cell-protocolo="props">
          <q-td class="text-brand-5 text-weight-bold" :props="props">{{
            props.row.protocolo
          }}</q-td>
        </template>
        <template v-slot:body-cell-metodo="props">
          <q-td class="text-brand-5 text-weight-bold" :props="props">{{
            props.row.metodo
          }}</q-td>
        </template>
        <template v-slot:body-cell-dataAtivacao="props">
          <q-td class="text-brand-5 text-weight-bold" :props="props">{{
            props.row.dataAtivacao?.split(" ")[0].split("-").reverse().join("/")
          }}</q-td>
        </template>
        <template v-slot:body-cell-status="props">
          <q-td :props="props">
            <div
              :style="
                props.row.dataDesativacao === null
                  ? 'background: #e8ffec; width: fit-content; padding: 0px 5px'
                  : 'background:#ffe9e9; color: #850202; width: fit-content; padding: 0px 5px'
              "
              class="row items-center text-brand-5 text-weight-bold"
            >
              <div
                v-if="props.row.dataDesativacao === null"
                class="elipse q-mr-xs bg-positive"
              ></div>
              <div v-if="props.row.dataDesativacao == null">
                <span v-if="props.row.dataDesativacao === null">Ativo</span>
                <span v-else
                  >Inativo<q-tooltip>{{
                    props.row.dataDesativacao
                  }}</q-tooltip></span
                >
              </div>
              <div v-else class="elipse q-mr-xs" style="background: red"></div>
            </div>
          </q-td>
        </template>
      </q-table>
    </div>
    <Transition name="slide-fade">
      <q-card v-if="rightDrawerOpen" class="drawer-modal">
        <div class="row q-pa-md text-weight-bold">
          <div class="row col-12 items-center">
            <q-icon
              style="cursor: pointer"
              name="close"
              class="q-mr-md"
              size="22px"
              @click="rightDrawerOpen = false"
            />
            <span style="font-size: 16px">
              <span>
                <span> Criar Novo </span>
              </span>
            </span>
          </div>
        </div>
        <q-scroll-area class="teste" style="width: 100%; height: 92%">
          <div
            class="column col-12 justify-between no-wrap"
            style="height: 90%"
          >
            <div class="q-px-md text-weight-bold">
              <div class="col-md-12 q-mt-xs">
                <SelecaoClientes
                  @enviarCliente="receberClienteCriacao"
                  :reset="resetCampos"
                />
              </div>
              <div class="col-md-12 q-mt-xs">
                <div class="col-md">
                  <SelecaoUnidades
                    @enviarUnidade="receberUnidadeCriacao"
                    :clienteId="dados.cliente?.clienteId"
                    :resetar="resetarUnidadeCriacao"
                  />
                </div>
              </div>
              <div class="col-md-12 q-mt-xs">
                <SelecaoSistemas
                  @enviarSistema="receberSistemaCriacao"
                  :reset="resetCampos"
                />
              </div>
              <div class="col-md-12 q-mt-xs">
                <div class="texto-titulo-input q-mb-xs">Tipo Integração</div>
                <q-select
                  v-model="dados.tipo"
                  :options="options.optionsTipo"
                  dense
                  outlined
                  class="input"
                />
              </div>
              <div class="col-md-12 q-mt-xs">
                <div class="texto-titulo-input q-mb-xs">Método Integração</div>
                <q-select
                  v-model="dados.metodo"
                  :options="options.optionsMetodo"
                  dense
                  outlined
                  class="input"
                />
              </div>
              <div class="col-md-12 q-mt-xs">
                <div class="q-mb-xs">Versão</div>
                <q-input dense outlined v-model="dados.versao" />
              </div>
              <div class="col-md-12 q-mt-xs">
                <div class="texto-titulo-input q-mb-xs">Protocolo</div>
                <q-select
                  v-model="dados.protocolo"
                  :options="options.optionsProtocolo"
                  dense
                  outlined
                  class="input"
                />
              </div>
              <div class="col-md-12 q-mt-xs">
                <div class="texto-titulo-input">Data Ativação</div>
                <q-input
                  v-model="dados.dataAtivacao"
                  dense
                  outlined
                  class="input"
                  placeholder="DD/MM/AAAA"
                  mask="##/##/####"
                >
                  <template v-slot:append>
                    <q-icon name="event" class="cursor-pointer">
                      <q-popup-proxy
                        cover
                        transition-show="scale"
                        transition-hide="scale"
                      >
                        <q-date
                          v-model="dados.dataAtivacao"
                          :locale="myLocale"
                          mask="DD/MM/YYYY"
                        >
                          <div class="row items-center justify-end">
                            <q-btn
                              v-close-popup
                              label="Fechar"
                              color="primary"
                              flat
                            />
                          </div>
                        </q-date>
                      </q-popup-proxy>
                    </q-icon>
                  </template>
                </q-input>
              </div>
            </div>
            <div class="q-px-md q-mt-md q-pb-md">
              <q-btn
                dense
                icon="check_circle_outline"
                label="Criar"
                no-caps
                color="positive"
                @click="cadastrarSistemaIntegrado()"
              />
            </div>
          </div>
        </q-scroll-area>
      </q-card>
    </Transition>
    <Transition name="slide-fade">
      <q-card v-if="rightDrawerOpenFiltro" class="drawer-modal">
        <div class="row q-pa-md text-weight-bold">
          <div class="row col-12 items-center">
            <q-icon
              style="cursor: pointer"
              name="close"
              class="q-mr-md"
              size="22px"
              @click="rightDrawerOpenFiltro = false"
            />
            <span style="font-size: 16px">
              <span>
                <span> Filtros </span>
              </span>
            </span>
          </div>
        </div>
        <q-scroll-area class="teste" style="width: 100%; height: 92%">
          <div
            class="column col-12 justify-between no-wrap"
            style="height: 90%"
          >
            <div class="q-px-md text-weight-bold">
              <div class="col-md-12 q-mt-xs">
                <SelecaoClientes
                  @enviarCliente="receberClienteFiltro"
                  :reset="resetCampos"
                  :model="filtros.cliente"
                />
              </div>
              <div class="col-md-12 q-mt-xs">
                <div class="col-md">
                  <SelecaoUnidades
                    @enviarUnidade="receberUnidadeFiltro"
                    :clienteId="filtros.cliente?.clienteId"
                    :model="filtros.unidade"
                    :resetar="resetarUnidadeFiltro"
                  />
                </div>
              </div>
              <div class="col-md-12 q-mt-xs">
                <SelecaoSistemas
                  @enviarSistema="receberSistemaFiltro"
                  :reset="resetCampos"
                  :model="filtros.sistema"
                />
              </div>
              <div class="col-md-12 q-mt-xs">
                <div class="texto-titulo-input q-mb-xs">Tipo Integração</div>
                <q-select
                  v-model="filtros.tipoIntegracao"
                  :options="options.optionsTipo"
                  dense
                  outlined
                  class="input"
                />
              </div>
              <div class="col-md-12 q-mt-xs">
                <div class="texto-titulo-input q-mb-xs">Método Integração</div>
                <q-select
                  v-model="filtros.metodo"
                  :options="options.optionsMetodo"
                  dense
                  outlined
                  class="input"
                />
              </div>
              <div class="col-md-12 q-mt-xs">
                <SelecaoVersao
                  @enviarVersao="receberVersaoFiltro"
                  :reset="resetVersaoFiltro"
                  :sistemaUuid="filtros.sistema?.uuid"
                  :model="filtros.versao"
                />
              </div>
              <div class="col-md-12 q-mt-xs">
                <div class="texto-titulo-input q-mb-xs">Protocolo</div>
                <q-select
                  v-model="filtros.protocolo"
                  :options="options.optionsProtocolo"
                  dense
                  outlined
                  class="input"
                />
              </div>
              <div class="col-md-12 q-mt-xs">
                <div class="texto-titulo-input">Data Ativação</div>
                <q-input
                  v-model="filtros.dataAtivacao"
                  dense
                  outlined
                  class="input"
                  placeholder="DD/MM/AAAA"
                  mask="##/##/####"
                >
                  <template v-slot:append>
                    <q-icon name="event" class="cursor-pointer">
                      <q-popup-proxy
                        cover
                        transition-show="scale"
                        transition-hide="scale"
                      >
                        <q-date
                          v-model="filtros.dataAtivacao"
                          :locale="myLocale"
                          mask="DD/MM/YYYY"
                        >
                          <div class="row items-center justify-end">
                            <q-btn
                              v-close-popup
                              label="Fechar"
                              color="primary"
                              flat
                            />
                          </div>
                        </q-date>
                      </q-popup-proxy>
                    </q-icon>
                  </template>
                </q-input>
              </div>
            </div>
            <div class="q-px-md q-mt-md q-pb-md">
              <q-btn
                dense
                icon="filter_alt"
                label="Filtrar"
                no-caps
                color="primary"
                @click="listarSistemasIntegrados()"
              />
            </div>
          </div>
        </q-scroll-area>
      </q-card>
    </Transition>
    <div
      v-if="rightDrawerOpen || rightDrawerOpenFiltro"
      @click="(rightDrawerOpen = false), (rightDrawerOpenFiltro = false)"
      class="mascara"
    ></div>
  </q-page>
</template>

<script setup>
import { useQuasar } from "quasar";
import { onMounted, ref, watch } from "vue";
import { useStore } from "vuex";

import SelecaoClientes from "../components/SelecaoClientes.vue";
import SelecaoSistemas from "../components/SelecaoSistemas.vue";
import SelecaoUnidades from "../components/SelecaoUnidade.vue";
import SelecaoVersao from "../components/SelecaoVersoes.vue";

const store = useStore();
const quasar = useQuasar();

const columns = [
  {
    name: "cliente",
    label: "Cliente",
    align: "left",
    field: "clienteId",
  },
  {
    name: "unidade",
    label: "Unidade",
    align: "left",
  },
  {
    name: "sistema",
    label: "Sistema",
    align: "left",
  },
  {
    name: "tipoIntegracao",
    label: "Tipo Int.",
    align: "left",
  },
  {
    name: "versao",
    label: "Versão",
    align: "left",
  },
  {
    name: "protocolo",
    label: "Protocolo",
    align: "left",
  },
  {
    name: "metodo",
    label: "Método",
    align: "left",
  },
  {
    name: "status",
    label: "Status",
    align: "left",
  },
  {
    name: "dataAtivacao",
    label: "Data Ativação",
    align: "left",
  },
];
const listaSistemasIntegracoes = ref([
  {
    cliente: "Vale",
    unidade: "Vale 2",
    sistema: "SOC",
  },
]);
let rightDrawerOpen = ref(false);
let rightDrawerOpenFiltro = ref(false);
const filtros = ref({
  cliente: { clienteId: "", ativo: "" },
  sistema: "",
  unidade: { clienteId: "", unidadeId: "", unidade: "" },
  tipoIntegracao: { label: "", value: "" },
  versao: "",
  dataAtivacao: "",
  dataDesativacao: "",
  metodo: "",
  protocolo: "",
});
const dados = ref({
  cliente: { clienteId: "", ativo: "" },
  sistema: { uuid: "", sistema: "" },
  unidade: { clienteId: "", unidadeId: "", unidade: "" },
  dataAtivacao: "",
  versao: "",
  metodo: "",
  protocolo: "",
});
let resetarUnidadeFiltro = ref(0);
let resetarUnidadeCriacao = ref(0);
let resetCampos = ref(0);
let resetVersao = ref(0);
let resetVersaoFiltro = ref(0);
const options = ref({
  optionsTipoIntegracao: [
    { label: "Consumo", value: "consumo" },
    { label: "Pessoa", value: "pessoa" },
  ],
  optionsVersao: [],
  optionsTipo: [
    { label: "Consumo", value: "consumo" },
    { label: "Pessoa", value: "pessoa" },
  ],
  optionsMetodo: [
    { label: "Envio", value: "envio" },
    { label: "Consumo", value: "consumo" },
  ],
  optionsProtocolo: [
    { label: "REST", value: "rest" },
    { label: "SOAP", value: "soap" },
  ],
});
let loading = ref(false);
const filtrosAplicados = ref([]);

const receberClienteFiltro = (value) => {
  aplicarFiltros(undefined, filtros.value.unidade?.unidade, "Unidade");
  if (value == null || value == "") {
    resetarUnidadeFiltro.value++;
    aplicarFiltros(
      value?.clienteId,
      filtros.value.cliente?.clienteId,
      "Cliente"
    );
    filtros.value.cliente = "";
    return;
  }
  aplicarFiltros(value?.clienteId, filtros.value.cliente?.clienteId, "Cliente");
  resetarUnidadeFiltro.value++;
  filtros.value.cliente = value;
};

const receberClienteCriacao = (value) => {
  if (value == null || value == "") {
    resetarUnidadeCriacao.value++;
    return;
  }
  resetarUnidadeCriacao.value++;
  dados.value.cliente = value;
};

const receberSistemaFiltro = (value) => {
  aplicarFiltros(undefined, filtros.value.versao?.versao, "Versão");
  if (value == null || value == "") {
    resetVersaoFiltro.value++;
    aplicarFiltros(value?.sistema, filtros.value.sistema?.sistema, "Sistema");
    filtros.value.sistema = "";
    return;
  }
  resetVersaoFiltro.value++;
  aplicarFiltros(value?.sistema, filtros.value.sistema?.sistema, "Sistema");
  filtros.value.sistema = value;
};

const receberSistemaCriacao = (value) => {
  if (value == null || value == "") {
    resetVersao.value++;
    return;
  }
  resetVersao.value++;
  dados.value.sistema = value;
};

const receberUnidadeFiltro = (value) => {
  if (value == null || value == "") {
    filtros.value.unidade = "";
    aplicarFiltros(value?.unidade, filtros.value.unidade?.unidade, "Unidade");
    return;
  }
  aplicarFiltros(value?.unidade, filtros.value.unidade?.unidade, "Unidade");
  filtros.value.unidade = value;
};

const receberUnidadeCriacao = (value) => {
  dados.value.unidade = value;
};

const receberVersaoFiltro = (value) => {
  if (value == null || value == "") {
    filtros.value.unidade = "";
    aplicarFiltros(value?.versao, filtros.value.versao?.versao, "Versão");
    return;
  }
  aplicarFiltros(value?.versao, filtros.value.versao?.versao, "Versão");
  filtros.value.versao = value;
};

const listarSistemasIntegrados = async () => {
  try {
    loading.value = true;
    const response = await store.dispatch("office/listarSistemasIntegrados", {
      clienteId: filtros.value.cliente.clienteId || null,
      unidadeId: filtros.value.unidade.unidadeId || null,
      sistemaUuid: filtros.value.sistema?.uuid || null,
      versao: filtros.value.versao.versao || null,
      tipo: filtros.value.tipo?.value || null,
      metodo: filtros.value.metodo?.value || null,
      protocolo: filtros.value.protocolo?.value || null,
      dataAtivacao:
        filtros.value.dataAtivacao.split("/").reverse().join("-") || null,
    });
    listaSistemasIntegracoes.value = response.data.resultado.dados;
    loading.value = false;
    rightDrawerOpenFiltro.value = false;
  } catch (error) {
    console.log(error);
  }
};

const cadastrarSistemaIntegrado = async () => {
  try {
    await store.dispatch("office/cadastrarSistemaIntegradoUnidade", {
      clienteId: dados.value.cliente.clienteId,
      unidadeId: dados.value.unidade.unidadeId,
      sistemaUuid: dados.value.sistema?.uuid,
      versao: dados.value.versao,
      tipo: dados.value.tipo?.value,
      metodo: dados.value.metodo?.value,
      protocolo: dados.value.protocolo?.value,
      dataAtivacao: dados.value.dataAtivacao.split("/").reverse().join("-"),
    });
    listarSistemasIntegrados();
    quasar.notify({
      message: "Cadastrado com sucesso",
      color: "positive",
      actions: [
        {
          label: "Fechar",
          color: "white",
          handler: () => {
            /* ... */
          },
        },
      ],
    });
    reset();
    rightDrawerOpen.value = false;
  } catch (error) {
    quasar.notify({
      message: "Erro ao cadastrar",
      color: "negative",
      actions: [
        {
          label: "Fechar",
          color: "white",
          handler: () => {
            /* ... */
          },
        },
      ],
    });
  }
};

watch(
  () => filtros.value.tipoIntegracao?.value,
  (novo, antigo) => {
    aplicarFiltros(novo, antigo, "Tipo Integração");
  }
);

watch(
  () => filtros.value.metodo?.value,
  (novo, antigo) => {
    aplicarFiltros(novo, antigo, "Método Integração");
  }
);

watch(
  () => filtros.value.protocolo?.value,
  (novo, antigo) => {
    aplicarFiltros(novo, antigo, "Protocolo");
  }
);

watch(
  () => filtros.value.dataAtivacao,
  (novo, antigo) => {
    aplicarFiltros(novo, antigo, "Data Ativação");
  }
);

const myLocale = {
  days: "Domingo_Segunda_Terça_Quarta_Quinta_Sexta_Sábado".split("_"),
  daysShort: "Dom_Seg_Ter_Quar_Quin_Sex_Sáb".split("_"),
  months:
    "Janeiro_Fevereiro_Março_Abril_Maio_Junho_Julho_Agosto_Setembro_Outubro_Novembro_Dezembro".split(
      "_"
    ),
  monthsShort: "Jan_Fev_Mar_Abr_Mai_Jun_Jul_Ago_Set_Out_Nov_Dez".split("_"),
  firstDayOfWeek: 1,
};

const reset = () => {
  dados.value = {
    cliente: { clienteId: "", ativo: "" },
    sistema: { uuid: "", sistema: "" },
    unidade: { clienteId: "", unidadeId: "", nome: "" },
    dataAtivacao: "",
    versao: "",
    metodo: "",
    protocolo: "",
  };
  resetCampos.value++;
};

const aplicarFiltros = (valorNovo, valorAtual, tipoFiltro) => {
  let index = filtrosAplicados.value.indexOf(`${tipoFiltro}: ${valorAtual}`);
  if (valorNovo == undefined && index == -1) {
    return;
  }
  if (valorNovo == undefined || valorNovo == "") {
    filtrosAplicados.value.splice(index, 1);
    return;
  }
  if (index == -1) {
    filtrosAplicados.value.push(`${tipoFiltro}: ${valorNovo}`);
  } else {
    filtrosAplicados.value.splice(index, 1, `${tipoFiltro}: ${valorNovo}`);
  }
};

onMounted(() => {
  listarSistemasIntegrados();
});
</script>

<style scoped>
.container {
  height: 100%;
}
.animacao {
  transition: all 0.5s;
  cursor: pointer;
}
.animacao:hover {
  -webkit-transform: scale(1.1);
  -ms-transform: scale(1.1);
  transform: scale(1.1);
}
.drawer-modal {
  border: 2px solid black;
  position: absolute;
  right: 0;
  width: 450px;
  position: fixed;
  top: 106px;
  height: calc(100% - 10px);
  max-height: 650px;
  border-radius: 10px 1px 1px 10px;
  margin: 2px;
  z-index: 3;
  overflow: hidden;
}
.slide-fade-enter-active {
  transition: all 0.5s ease-out;
}
.slide-fade-leave-active {
  transition: all 0.5s cubic-bezier(1, 0.5, 0.8, 1);
}

.slide-fade-enter-from,
.slide-fade-leave-to {
  transform: translateX(400px);
}
.mascara {
  background-color: black;
  height: 100%;
  width: 100%;
  position: fixed;
  top: 0;
  left: 0;
  z-index: 2;
  opacity: 0.4;
}
.elipse {
  width: 15px;
  height: 15px;
  border-radius: 100%;
}
.card-nome-filtro {
  background-color: #dfebf2;
  padding: 5px 10px;
}
@media (max-width: 1200px) {
  .drawer-modal {
    max-height: 85%;
  }
}
@media (max-width: 900px) {
  .drawer-modal {
    max-height: 80%;
    top: 118px;
  }
}
@media (max-width: 600px) {
  .drawer-modal {
    max-height: 80%;
    top: 107px;
  }
}
</style>
